// extracted by mini-css-extract-plugin
export default {"titleText":"gSD1lyGrlJQMR2N4ZpWo","nestedCountButton":"itzLprvJNmk8WJX7mrTO","nestedPosition":"W38vW1hnApASk50UW9d5","nestedLabel":"X4Cqfw9oi44q0bJhmPo9"};